import gql from "graphql-tag";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/react-hooks";
import get from "lodash/get";

export const COMMENTS_QUERY = gql`
  query useComments($workId: String!) {
    comments(workId: $workId) {
      id
      userId
      workId
      comment
      createdAt
      canDelete
      canReply
      canReport
      user {
        id
        userName
        displayName
        avatar
      }
      commentReplies {
        id
        userId
        workId
        comment
        createdAt
        canDelete
        canReply
        canReport
        user {
          id
          userName
          displayName
          avatar
        }
      }
    }
  }
`;

export const useComments = ({ workId }) => {
  const { data, loading, error } = useQuery(COMMENTS_QUERY, {
    variables: {
      workId,
    },
    skip: !workId,
    ssr: false,
  });
  const comments = get(data, "comments", null) || [];

  return {
    comments,
    commentsLoading: loading,
    commentsError: error,
  };
};

const userShape = PropTypes.shape({
  avatar: PropTypes.string,
  displayName: PropTypes.string,
  id: PropTypes.string,
  userName: PropTypes.string,
});

const repliesShape = PropTypes.arrayOf(
  PropTypes.shape({
    comment: PropTypes.string,
    createdAt: PropTypes.string,
    id: PropTypes.string,
    parentId: PropTypes.string,
    user: userShape,
    userId: PropTypes.string,
    workId: PropTypes.string,
    canDelete: PropTypes.bool,
    canReply: PropTypes.bool,
    canReport: PropTypes.bool,
  })
);

export const commentsShape = PropTypes.arrayOf(
  PropTypes.shape({
    comment: PropTypes.string,
    commentReplies: repliesShape,
    createdAt: PropTypes.string,
    id: PropTypes.string,
    user: userShape,
    userId: PropTypes.string,
    workId: PropTypes.string,
    canDelete: PropTypes.bool,
    canReply: PropTypes.bool,
    canReport: PropTypes.bool,
  })
);
